/**  @module Apparel/PrintDesign/PrintPositionMixin */
define([
	"dojo/_base/declare",
	"csi/locale"
], function(declare,locale) {
	
	return declare(null, {
		/**
		 * @override
		 * Don't allow action if Positions count is going to get more than what is set on Print Design node.
		 */
		preProcess: function() {
			var rev = this.getParent();
			if(this.validatePrintPositionCount(rev)){
				this.inherited(arguments);
			}
		},
		
		/**
		 * Display error message and return false if Positions count is going to get more than what is set on Print Design node,
		 * Otherwise return true.  
		 * @return {boolean}
		 */
		validatePrintPositionCount: function(rev) {
			if ((rev.Positions.length)+1 > rev.PrintPositionsCount) {
				this.displayErrorDialog({message:this.getString("_ErrorInPrintPositionsCount", [rev.PrintPositionsCount])});
				return false;
			}
			else {
				return true;
			}
		}
	});
});
